import React, { useCallback, useMemo, useState } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SelectableCardList, getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';

const TagSetupMethodViewUnstyled = (props) => {
  const {
    classes,
    selectedItem,
    i18n,
    updateTagSetupMethod,
  } = props;

  const [selectedTagSetupMethod, setSelectedTagSetupMethod] = useState(selectedItem);

  const tagSetupMethods = useMemo(() => {
    const methods = [
      {
        id: 'installTag',
        title: i18n.getString(_TL_(('Install the tag yourself'))),
        description: i18n.getString(_TL_(('We\'ll provide the instructions so you can add the tracking tag to your website\'s code.'))),
        iconName: 'Edit',
      },
      {
        id: 'emailTag',
        title: i18n.getString(_TL_(('Send the tag to a developer'))),
        description: i18n.getString(_TL_(('We\'ll send the tracking tag and instructions to the people you specify, so they can add the tag to your website\'s code.'))),
        iconName: 'Mail',
      },
    ];

    methods.push({
      id: 'platformTag',
      title: i18n.getString(_TL_(('Add the tag through a website editing platform'))),
      description: i18n.getString(_TL_(('We\'ll provide instructions for adding the tracking tag through an editing platform, such as WordPress, Wix, Shopify, or BigCommerce.'))),
      glyphIconName: 'ba-AdUnitChannel',
    });

    // TODO: remove aid check once MT support GTM setup at customer level
    methods.push({
      id: 'gtmTag',
      title: i18n.getString(_TL_('Automatically add the tracking tag through Google Tag Manager')),
      description: i18n.getString(_TL_('If you are already using Google Tag Manager for your website, we can automatically set up the tracking tag for you.')),
      glyphIconName: 'ba-AdUnitChannel',
    });

    return methods;
  }, [i18n]);

  const onSelectTagSetupMethod = useCallback((option) => {
    setSelectedTagSetupMethod(option);
    updateTagSetupMethod(option);
  }, [updateTagSetupMethod]);

  return (
    <div className={classes.contentBlock}>
      <SelectableCardList
        contents={tagSetupMethods}
        selectedItem={selectedTagSetupMethod}
        onItemSelected={onSelectTagSetupMethod}
        useLargeCards
      />
    </div>
  );
};

TagSetupMethodViewUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getStepStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  selectedItem: PropTypes.string.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  updateTagSetupMethod: PropTypes.func.isRequired,
};

export const TagSetupMethodView = withDefaultStyles(TagSetupMethodViewUnstyled, getStepStyles);
